(function () {
  var loadPromise;
  var openPromise;
  var pendingOpen;
  var messengerIsOpen = false;
  var listenersRegistered = false;
  var zendeskScriptUrl = 'https://static.zdassets.com/ekr/snippet.js?key=6856ecae-0aa6-4f39-aea5-ffac195d4597';
  var chatSelector = '#conversation-badge, .chat_now, .global_support, .compare_chat, #chat-target-id';

  window.loadZendeskMessenger = function () {
    // A pending request takes priority over the snippet's early zE queue.
    if (loadPromise) return loadPromise;
    if (typeof window.zE === 'function') return Promise.resolve();

    loadPromise = new Promise(function (resolve, reject) {
      var script = document.getElementById('ze-snippet');
      var isNewScript = !script;
      var ownsScript = isNewScript || script.getAttribute('data-blacklyte-zendesk') === 'true' || script.getAttribute('src') === zendeskScriptUrl;
      var initialZendeskApi = window.zE;

      if (isNewScript) {
        script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src = zendeskScriptUrl;
        script.async = true;
        script.setAttribute('data-blacklyte-zendesk', 'true');
      }

      function cleanup() {
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
      }

      function onLoad() {
        if (typeof window.zE !== 'function') {
          onError();
          return;
        }
        cleanup();
        // This confirms only the snippet; the open event confirms the UI below.
        resolve();
      }

      function onError() {
        cleanup();
        if (ownsScript) {
          script.remove();
          // Preserve an API that another integration created while this request was pending.
          if (window.zE === initialZendeskApi || typeof window.zE !== 'function') {
            window.zE = initialZendeskApi;
          }
        }
        reject(new Error('Zendesk Messenger could not be loaded.'));
      }

      script.addEventListener('load', onLoad);
      script.addEventListener('error', onError);
      if (isNewScript) document.head.appendChild(script);
    }).catch(function (error) {
      loadPromise = null;
      listenersRegistered = false;
      throw error;
    });

    return loadPromise;
  };

  function setFallbackVisible(visible) {
    var fallback = document.getElementById('zendesk-chat-fallback');
    if (fallback) fallback.hidden = !visible;
  }

  function finishOpen(attempt, opened, error) {
    if (pendingOpen !== attempt) return;
    window.clearTimeout(attempt.timeout);
    pendingOpen = null;
    setFallbackVisible(!opened);
    if (error) console.warn('[Blacklyte] Chat could not be opened.', error);
    attempt.resolve(opened);
  }

  function registerMessengerListeners() {
    if (listenersRegistered) return;
    window.zE('messenger:on', 'open', function () {
      messengerIsOpen = true;
      setFallbackVisible(false);
      if (pendingOpen) finishOpen(pendingOpen, true);
    });
    window.zE('messenger:on', 'close', function () {
      messengerIsOpen = false;
    });
    listenersRegistered = true;
  }

  window.openZendeskMessenger = function () {
    if (openPromise) return openPromise;
    if (messengerIsOpen) return Promise.resolve(true);
    setFallbackVisible(false);

    openPromise = new Promise(function (resolve) {
      var attempt = { resolve: resolve };
      pendingOpen = attempt;
      // Bound the whole user action, including download and Messenger initialization.
      attempt.timeout = window.setTimeout(function () {
        // Removing a script does not cancel its initialization. Keep the same SDK.
        finishOpen(attempt, false, new Error('Zendesk Messenger did not open in time.'));
      }, 15000);

      window.loadZendeskMessenger()
        .then(function () {
          // A late download must not open chat after this attempt has expired.
          if (pendingOpen !== attempt) return;
          registerMessengerListeners();
          window.zE('messenger', 'open');
        })
        .catch(function (error) {
          finishOpen(attempt, false, error);
        });
    }).then(function (opened) {
      openPromise = null;
      return opened;
    });

    return openPromise;
  };

  // Delegation also covers product variant replacements and section reloads.
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest(chatSelector);
    if (!target) return;
    event.preventDefault();
    window.openZendeskMessenger();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var target = event.target.closest && event.target.closest(chatSelector);
    if (!target || target.matches('button, input, a[href]') || event.repeat) return;
    event.preventDefault();
    window.openZendeskMessenger();
  });
})();
